export default __webpack_public_path__ + "static/placeholder-4-3-87ec97f8de828ec81ab277dd55a2dab2.png";